import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth-provider/auth-provider"

export const AdminRoute = () => {
    const auth =  useAuth();
    if(!auth.user.isAdmin) return <Navigate to="/" />;
    return <Outlet />;
}